// The Oireachtas screens an event-day job device can open in the admin app
// (card 540f21a4), each with the job functions that show it. The paths are
// the admin's own screens; the device's home lists the ones its job includes,
// and the device's routes only lead to those. (Feis devices use the web app.)
export const OX_SCREENS = [
  { key: 'checkin', title: 'Check-in', description: 'Who is checked in, per round', icon: 'how_to_reg', path: '/oireachtas/check-in', any: ['ox.checkin.view', 'ox.checkin.mark'] },
  { key: 'tabulation', title: 'Enter Scores', description: 'Competition, round and judge — enter the sheet', icon: 'edit_note', path: '/oireachtas/tabulation', query: { mode: 'enter' }, any: ['ox.scores.enter'] },
  // the same screen's hub (Devin 2026-10-28): a competition's scores by round
  { key: 'viewScores', title: 'View Scores', description: 'A competition\'s scores by round — sign-offs and recall', icon: 'table_view', path: '/oireachtas/tabulation', any: ['ox.scores.enter'] },
  {
    key: 'status',
    title: 'Status',
    description: 'Tabulation progress for the whole event',
    icon: 'fact_check',
    path: '/oireachtas/status',
    // publishing jobs publish from here too (their functions read the status)
    any: ['ox.status.view', 'ox.recall.publish', 'ox.recall.unpublish', 'ox.results.publish', 'ox.results.unpublish'],
  },
  {
    key: 'results',
    title: 'Results',
    description: 'Check, publish and round awards',
    icon: 'emoji_events',
    path: '/oireachtas/results',
    any: ['ox.results.check', 'ox.roundawards', 'ox.results.publish', 'ox.results.unpublish', 'ox.recall.publish', 'ox.recall.unpublish'],
  },
  { key: 'draw', title: 'Competitions', description: 'Locked running orders and numbers', icon: 'format_list_numbered', path: '/oireachtas/draw', any: ['ox.draws.read'] },
  { key: 'competitors', title: 'Competitors', description: 'Every dancer and team', icon: 'groups', path: '/oireachtas/competitors', any: ['ox.competitors.view'] },
  { key: 'printResults', title: 'Print Results', description: 'Results per competition and the results book', icon: 'print', path: '/oireachtas/print/results', any: ['ox.print.results'] },
  { key: 'printCards', title: "Competitor #'s", description: 'Number cards', icon: 'badge', path: '/oireachtas/print/number-cards', any: ['ox.print.cards'] },
  { key: 'printCheckin', title: 'Check-in Sheets', description: 'Per competition, per round', icon: 'checklist', path: '/oireachtas/print/check-in', any: ['ox.print.sheets'] },
  { key: 'printScores', title: 'Score Sheets', description: 'Blank sheets per judge and round', icon: 'description', path: '/oireachtas/print/score-sheets', any: ['ox.print.sheets'] },
];

// The routes in the device's tree: each screen's route (prints share one) and
// the functions that open it.
const anyOf = (key) => OX_SCREENS.find((s) => s.key === key).any;
export const OX_ROUTES = [
  { path: '/oireachtas/check-in', key: 'checkin', any: anyOf('checkin') },
  // Enter Scores and View Scores: one screen
  { path: '/oireachtas/tabulation', key: 'tabulation', any: anyOf('tabulation') },
  { path: '/oireachtas/status', key: 'status', any: anyOf('status') },
  { path: '/oireachtas/results', key: 'results', any: anyOf('results') },
  { path: '/oireachtas/draw', key: 'draw', any: anyOf('draw') },
  { path: '/oireachtas/competitors', key: 'competitors', any: anyOf('competitors') },
  { path: '/oireachtas/print/:artifact', key: 'print', any: ['ox.print.results', 'ox.print.cards', 'ox.print.sheets'] },
];

export const screenLink = (screen, event) =>
  `${screen.path}?id=${event._id}${screen.query ? `&${new URLSearchParams(screen.query).toString()}` : ''}`;
